import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationsLevel } from "../../../lib/enums";
import api from "../../../services/api";
import { show } from "../../../notifications/notifications";
import { AddTagsRequest, AddedTagResponse } from "../../@types";
import { USER_TAGS_KEY } from "../queryKeys";
import { formatTagNotificationMessage } from "../utils";

const useAddTags = () => {
  const addTags = (data: AddTagsRequest) => api.addUserTags(data);
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: addTags,
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({ queryKey: [USER_TAGS_KEY] });
      const addedTags = data.map((item: AddedTagResponse) => item?.added_tag);
      const message = formatTagNotificationMessage("Added tag", addedTags);
      show({
        level: NotificationsLevel.INFO,
        message
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: "Something went wrong. Please try again."
      });
    }
  });

  return { mutate: mutateAsync };
};

export default useAddTags;
